import React from "react";
import { usePermissions } from "../../hooks/usePermissions";

interface PermissionGuardProps {
  category: string;
  subcategory?: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  showIf?: boolean; // Optional override
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  category,
  subcategory,
  children,
  fallback = null,
  showIf = true,
}) => {
  const { hasCategoryAccess, hasSubcategoryAccess } = usePermissions();

  if (!showIf) {
    return <>{fallback}</>;
  }

  if (subcategory) {
    const hasAccess = hasSubcategoryAccess(category, subcategory);
    return hasAccess ? <>{children}</> : <>{fallback}</>;
  }

  const hasAccess = hasCategoryAccess(category);
  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default PermissionGuard;
